export default {
  cage: { id: 'cage' },
  logbook_history: { id: 'logbook_history' },
  type: { id: 'type' },
  status: { id: 'status' },
  delete_log: { id: 'delete_log' },
  delete_log_message: { id: 'delete_log_message' },
  logged: { id: 'logged' },
  time: { id: 'time' },
  comment: { id: 'comment' },
  rate: { id: 'rate' },
  value: { id: 'value' },
}
